import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';


export function CsfPivotalMemberLogin(props) {

  const [loginName, setLoginName] = useState('');
  const [loginPassword, setLoginPassword] = useState('');

  const [usernameLabel, setUsernameLabel] = useState(props.translations.usernameLabel);
  const [passwordLabel, setPasswordLabel] = useState(props.translations.passwordLabel);

  const [errorSummary, setErrorSummary] = useState();
  const [isError, setIsError] = useState(false);

  const _getFormFieldWrapperClasses = function () {
    return "js-form-item form-item js-form-type-password form-item-pass js-form-item-pass form-group" +
      (isError ? " form-item--error error" : "");
  }

  function displayFormError() {
    // change labels and add error classes on wrappers
    setIsError(true);
    setUsernameLabel(props.translations.usernameLabelError);
    setPasswordLabel(props.translations.passwordLabelError);

    setErrorSummary(
      <div className="messagebox py-3 px-2 px-md-5 messagebox-error">
        <div className="grid-container-large">
          <div className="d-flex flex-column flex-lg-row align-items-center">
            <p className="messagebox-text"
               dangerouslySetInnerHTML={{__html: props.translations.errorMessage}}>
            </p>
          </div>
        </div>
      </div>
    );
  }

  function startLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll(".ui-loader-background");
    const loader = document.querySelectorAll("#loader");

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        if (background.length > 1 || loader.length > 1) {
          background[1].style.display = 'block';
          loader[1].style.visibility = 'visible';
        }
        else {
          background[0].style.display = 'block';
          loader[0].style.visibility = 'visible';
        }
      }
    }
  }

  function stopLoadingSpinner() {
    // spinner markup is already in pages
    const background = document.querySelectorAll(".ui-loader-background");
    const loader = document.querySelectorAll("#loader");

    if (background !== undefined && background !== null) {
      if (loader !== undefined && loader !== null) {
        if (background.length > 1 || loader.length > 1) {
          background[1].style.display = 'none';
          loader[1].style.visibility = 'hidden';
        }
        else {
          background[0].style.display = 'none';
          loader[0].style.visibility = 'hidden';
        }
      }
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    //Show spinner
    startLoadingSpinner();


    const recipeUrl = props.apiUrl;
    const postBody = {
      userName: loginName,
      password: loginPassword,
      scope: "full refresh_token"
    };

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': props.apiEnv
      },
      body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
      .then(res => res.json())
      .then(data => {

        if (data.success !== true) {
          displayFormError();
          stopLoadingSpinner();
          return;
        }
        // call api to persist data and login to drupal
        completeSiteLogin({
          accessToken: data.payload.access_token,
          tokenType: data.payload.token_type,
          tokenExpiresIn: data.payload.expires_in,
          refreshtoken: data.payload.refresh_token,
          username: data.payload.environmentName,
          envName: data.payload.user_name,
        });


      }).catch(function (error) {
      console.log(error);
      // display error
      displayFormError();
      /* hide spinner: only on error, successful login is redirected */
      stopLoadingSpinner();
    });

  }

  function completeSiteLogin(loginData) {

    const url = "/csf-api-pivotal/login-user-to-site";

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': props.apiEnv
      },
      body: JSON.stringify(loginData)
    };

    fetch(url, requestMetadata)
      .then(res => {
        if (!res.ok) {
          throw new Error("HTTP status " + res.status);
        }
        return res;
      })
      .then(res => res.json())
      .then(data => {

        if (data.redirect !== undefined) {
          // success: redirect visitor to default logged-in page
          window.location.href = data.redirect;
        } else {
          // display error
          displayFormError();
          /* hide spinner: only on error, successful login is redirected */
          stopLoadingSpinner();
        }

      }).catch(function (error) {
      console.log(error);
      // display error
      displayFormError();
      /* hide spinner: only on error, successful login is redirected */
      stopLoadingSpinner();
    });

  }

  return (
    <form className="user-login-form" autoComplete="off"
          onSubmit={handleSubmit}>

      {errorSummary}

      <div className={_getFormFieldWrapperClasses()}>
        <label htmlFor="loginFormUsernameInput"
               className="js-form-required form-required">
          {usernameLabel}
        </label>
        <input autoCorrect="none" autoCapitalize="none" spellCheck="false"
               type="text"
               id="loginFormUsernameInput"
               name="loginFormUsernameInput"
               value={loginName}
               onChange={e => setLoginName(e.target.value)}
               size="15" maxLength="60"
               className="form-text required" required="required"
               aria-required="true"/>
      </div>


      <button type="button" className="btn btn-tooltip ml-1 mt-4 trigger-certificate_numberModal" data-toggle="modal" data-target="#certificate_numberModal">?</button>

      <div className="modal fade" id="certificate_numberModal" tabIndex="-1" role="dialog" aria-labelledby="certificate_numberModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <h4 className="color-black">
                  { props.translations.certificateModalTitle }
                </h4>
                <p>
                  { props.translations.certificateModalSubTitle }
                </p>
                <p>{ props.translations.certificateModalToFindItLabel }
                  <a className="font-weight-bold" href={ props.translations.certificateModalToFindItLinkHref }>
                    { props.translations.certificateModalToFindItLinkLabel }
                  </a>
                </p>
              </div>
              <div>
                <h3>
                  { props.translations.certificateModalDataRecordTitle }
                </h3>
                <p>
                  { props.translations.certificateModalDataRecordFirstLastName }
                </p>
                <p className="bg-yellow">
                  { props.translations.certificateModalDataRecordCertificate }
                </p>
                <p>
                  { props.translations.certificateModalDataRecordNRD }
                </p>
                <p>
                  { props.translations.certificateModalDataRecordClientNumber }
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-dark mb-2" data-dismiss="modal">
                { props.translations.certificateModalClose }
              </button>
            </div>
          </div>
        </div>
      </div>


      <div
        className={_getFormFieldWrapperClasses()}>
        <label htmlFor="loginFormPasswordInput"
               className="js-form-required form-required">
          {passwordLabel}
        </label>
        <div className="field__password">
          <input data-drupal-selector="edit-pass" type="password"
                 id="loginFormPasswordInput" name="loginFormPasswordInput"
                 size="15" maxLength="128"
                 value={loginPassword}
                 onChange={e => setLoginPassword(e.target.value)}
                 className="form-text required" required="required"
                 aria-required="true"/>
          <a className="togglepass">
            <span className="passIcon hidePass">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"></path></svg></span>
            <span className="passIcon showPass" style={{display: 'none'}}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512">{/* Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}
                <path
                  d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z"></path></svg></span>
          </a>
        </div>
      </div>

      <br/>
      <a href={ props.translations.resetPasswordHref }
         title={ props.translations.resetPasswordTitle }
         className='request-password-link' >
        { props.translations.resetPasswordLabel }
      </a>


      <div data-drupal-selector="edit-actions"
           className="form-actions js-form-wrapper form-wrapper"
           id="edit-actions">
        <input type="submit"
               name="op"
               value={ props.translations.submitLabel }
               className="button js-form-submit form-submit btn-primary btn"/>
      </div>


    </form>
  );
}


window.addEventListener('DOMContentLoaded', () => {

  const domNode = document.getElementById('CSFPivotalMemberLogin');

  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const translations = {
      errorMessage: domNode.getAttribute("data-text-error-message"),
      usernameLabel: domNode.getAttribute("data-text-username-label"),
      usernameLabelError: domNode.getAttribute("data-text-username-label-error"),
      passwordLabel: domNode.getAttribute("data-text-password-label"),
      passwordLabelError: domNode.getAttribute("data-text-password-label-error"),
      submitLabel: domNode.getAttribute("data-text-submit-label"),
      resetPasswordHref: domNode.getAttribute("data-resetpassword-href"),
      resetPasswordLabel: domNode.getAttribute("data-resetpassword-label"),
      resetPasswordTitle: domNode.getAttribute("data-resetpassword-title"),
      certificateModalTitle: domNode.getAttribute("data-certificatemodal-title"),
      certificateModalSubTitle: domNode.getAttribute("data-certificatemodal-subtitle"),
      certificateModalToFindItLabel: domNode.getAttribute("data-certificatemodal-finditlabel"),
      certificateModalToFindItLinkLabel: domNode.getAttribute("data-certificatemodal-finditlinklabel"),
      certificateModalToFindItLinkHref: domNode.getAttribute("data-certificatemodal-finditlinkhref"),
      certificateModalDataRecordTitle: domNode.getAttribute("data-certificatemodal-datarecordtitle"),
      certificateModalDataRecordFirstLastName: domNode.getAttribute("data-certificatemodal-datarecordfirstlastname"),
      certificateModalDataRecordCertificate: domNode.getAttribute("data-certificatemodal-datarecordcertificate"),
      certificateModalDataRecordNRD: domNode.getAttribute("data-certificatemodal-datarecordnrd"),
      certificateModalDataRecordClientNumber: domNode.getAttribute("data-certificatemodal-datarecordnrdclientnumber"),
      certificateModalClose: domNode.getAttribute("data-certificatemodal-close"),
    };

    root.render(<CsfPivotalMemberLogin
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      translations={translations}
    />);
  }
});
